
export const small = 4
export const smedium = 6
export const medium = 8
export const large = 16
